import Cookies from "js-cookie";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { buildRpcViewerUrl } from "../../hermesclient/mailbox-utils";
import { ROUTES } from "../../routes/paths";
import { AuthTokenManager } from "../../services/auth-token-manager";
import { setUser } from "../../state/slices/user-slice";

export function useNavigationActions() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const logout = () => {
    dispatch(setUser({ user: undefined }));
    Cookies.remove("SESS");
    Cookies.remove("SESS-US");

    const authManager = AuthTokenManager.getInstance();
    authManager?.clearToken();

    console.log("[Navigation] User logged out, redirecting to login");
    navigate(ROUTES.AUTH.LOGIN);
  };

  const openRpcViewer = async () => {
    const url = await buildRpcViewerUrl();
    window.open(url, "_blank");
  };

  return {
    logout,
    openRpcViewer,
  };
}
